"use strict";

var _interopRequireDefault = require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es6.function.name");
var _objectSpread2 = _interopRequireDefault(require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime-corejs2/helpers/objectSpread2.js"));
var _vuex = require("vuex");
var _UserCard = _interopRequireDefault(require("./components/UserCard"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// import Account from './components/Account'
var _default = exports.default = {
  name: 'Profile',
  // components: { UserCard, Account },
  components: {
    UserCard: _UserCard.default
  },
  data: function data() {
    var _this = this;
    var validateOldPassword = function validateOldPassword(rule, value, callback) {
      if (_this.errorKeys.indexOf('oldPassword') >= 0) {
        callback(new Error(_this.errorInfo['oldPassword']));
        _this.resetError('oldPassword');
      } else {
        callback();
      }
    };
    var validateNewPassword = function validateNewPassword(rule, value, callback) {
      if (_this.errorKeys.indexOf('newPassword') >= 0) {
        callback(new Error(_this.errorInfo['newPassword']));
        _this.resetError('newPassword');
      } else {
        callback();
      }
    };
    var validateConfirmPassword = function validateConfirmPassword(rule, value, callback) {
      if (value !== _this.modifyPassVal.newPassword) {
        callback(new Error(_this.$t('sysUser.error.confirmPassword')));
      } else if (_this.errorKeys.indexOf('confirmPassword') >= 0) {
        callback(new Error(_this.errorInfo['confirmPassword']));
        _this.resetError('confirmPassword');
      } else {
        callback();
      }
    };
    return {
      formLabelWidth: '120px',
      isLoading: false,
      dialogStatus: 'create',
      isShowModifyPass: false,
      modifyPassVal: {
        oldPassword: '',
        newPassword: '',
        confirmPassword: ''
      },
      initModifyPassVal: {
        oldPassword: '',
        newPassword: '',
        confirmPassword: ''
      },
      modifyPassRules: {
        oldPassword: [{
          required: true,
          trigger: ['change'],
          validator: validateOldPassword
        }],
        newPassword: [{
          required: true,
          trigger: ['change'],
          validator: validateNewPassword
        }],
        confirmPassword: [{
          required: true,
          trigger: ['change'],
          validator: validateConfirmPassword
        }]
      },
      errorKeys: [],
      errorInfo: {}
    };
  },
  computed: (0, _objectSpread2.default)({}, (0, _vuex.mapGetters)(['userInfo', 'name', 'avatar'])),
  watch: {
    isLoading: function isLoading(newValue) {
      // pc unlock 锁屏会导致页面晃动
      if (newValue) {
        this.loadingComponent = this.$loading({
          // lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(255, 255, 255, 0)'
        });
      } else {
        if (this.loadingComponent) {
          this.loadingComponent.close();
        }
      }
    }
  },
  created: function created() {
    this.getUser();
  },
  methods: {
    getUser: function getUser() {
      this.user = {
        name: this.name || '',
        avatar: this.avatar || ''
      };
    },
    resetError: function resetError(val) {
      if (val) {
        var index = this.errorKeys.indexOf(val);
        this.errorKeys.splice(index, 1);
        delete this.errorInfo.val;
      } else {
        this.errorKeys = [];
        this.errorInfo = {};
      }
    },
    modifyPassword: function modifyPassword() {
      var _this2 = this;
      this.dialogStatus = 'modifyPass';
      this.modifyPassVal = {
        oldPassword: '',
        newPassword: '',
        confirmPassword: ''
      };
      this.isShowModifyPass = true;
      this.$nextTick(function () {
        _this2.$refs['modifyPassDataForm'].clearValidate();
      });
    },
    saveModifyPass: function saveModifyPass() {
      var _this3 = this;
      this.$refs.modifyPassDataForm.validate(function (valid) {
        if (!valid) return;
        _this3.isLoading = true;
        _this3.$api.sysUser.passModify(_this3.modifyPassVal).then(function (res) {
          _this3.isLoading = false;
          _this3.isShowModifyPass = false;
        }).catch(function (err) {
          if (err.errorInfos && err.errorInfos.length > 0) {
            _this3.resetError();
            err.errorInfos.forEach(function (item) {
              _this3.errorKeys.push(item.key);
              _this3.errorInfo[item.key] = item.errMsg;
            });
            _this3.$refs['modifyPassDataForm'].validate(function (valid) {
              console.log(valid);
            });
          }
          _this3.isLoading = false;
          // this.$message.error('保存失败')
        });
      });
    }
  }
};